import type {MentionMeta} from './commentMentionTokens';

export interface CommentNotificationPayload {
  documentId?: string;
  threadId: string;
  commentId: string;
  mentions: MentionMeta[];
  authorName?: string;
  excerpt?: string;
}

/**
 * Stub for future email / in-app notification integration.
 * Call after saving a comment that includes @mentions.
 */
export const notifyMentionedUsers = (
  payload: CommentNotificationPayload
): void => {
  if (!payload.mentions?.length) return;

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('[comments] mention notification stub', payload);
  }
};
